import { Role } from '../models/role'

import regionRoutes, * as regionRouter from './RCompetitionRegionOrganization'
import videoRegionRoutes, * as videoRegionRouter from './RVideoCompetitionRegionOrganization'

import competitionMenuIcon from '@/assets/images/icon_menu_competition@2x.png'
import competitionMenuIconActive from '@/assets/images/icon_menu_competition_active@2x.png'

const LayoutEmpty = () => import('../views/LayoutEmpty.vue')

export default [
  {
    path: 'competition',
    name: 'competition_organization',
    component: LayoutEmpty,
    meta: {
      title: '在线比赛',
      icon: competitionMenuIcon,
      iconActive: competitionMenuIconActive,
      showMenu: true,
      roles: [Role.Organization, Role.OrganizationJudge, Role.Offical],
    },
    redirect: regionRoutes[0],
    children: [...regionRoutes, ...videoRegionRoutes],
  },
]

export { regionRouter, videoRegionRouter }
